import { Stack } from '@my/ui'
import { ImageBlock } from './image.block'
import { SolitoImage } from 'solito/image'
import { BlockRendererProps } from '../block-renderer'

export type ImageComponentProps = ImageBlock & BlockRendererProps["extraProps"]

export const ImageComponent = (props: ImageComponentProps) => {
  return (
    <Stack
      flexShrink={1}
      overflow="hidden"
      br="$3"
      aspectRatio={props.image.width / props.image.height}
      maxHeight={props.image.height}
    >
      <SolitoImage
        src={props.image.url}
        alt={props.image.alt || ''}
        fill
        contentFit="cover"
        sizes="(max-width: 768px) 100vw, 600px"
        priority={props.imagePriority}
      />
    </Stack>
  )
}
